import GLOBALS from "../app/globals.ts";
import { Utils } from './utils-service.js';

export const UserService = {

    login: function(loginField, passwordField, rememberMeField) {

        return new Promise((resolve, reject) => {
            let data = {
                loginField: loginField,
                passwordField: passwordField
            };

            Utils.httpPost(
                    GLOBALS.API_URL + "PoliciaCuadrantes/login",
                    data,
                )
                .then(function(data) {

                    if (data.length == 0) {
                        reject(`usuario y/o contraseña erronea`);
                    } else {
                        resolve({
                            id: data[0].id,
                            email: data[0].email,
                            telefono: data[0].telefono,
                            token: data[0].token,
                            username: data[0].usuario,
                            extraInfo: data[0].extraInfo,
                            fk_idPersonal: data[0].fk_idPersonal,
                            funcionalidades: data[0].funcionalidades,
                            /* rememberMe: rememberMeField, */
                        });
                    }
                })
                .catch(function(error) {
                    reject(error);
                });
        });
    },

    getUsers: function(idUser) {

        if (idUser == 0 || typeof(idUser) === 'undefined') {
            console.log("GET : " + GLOBALS.API_URL + "PoliciaCuadrantes/usuarios/");
            return Utils.httpGet(
                GLOBALS.API_URL + "PoliciaCuadrantes/usuario",
                'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOiIxNjIxNzYwODI5IiwiaWF0IjoiMTYyMTczMjAyOSIsImlkUHJvZmlsZSI6OCwianRpIjoiQjBCNkYwNjctQkZGNy00Qzc3LUJBNzUtQkMzQTdBRUJEREJDIiwic2VjcmV0IjoiWFRXTFhJTTRQNVFXVlZHSjNBU1lMWUNIQjc2QkdRS1RVQVRRVkxSVzM2SE1OQUREN0pRU0RCVzJVQVdTSUhKSUJJSVdWT0tUWlU3VVRMVjJBMjZKVUhYTjVENlk1NUZYVEpSS1cyUSIsInN1YiI6MjMsInZhbGlkaXR5IjoyODgwMH0=.rzmIzGd7Txm5qUAYumToeoiARzgWNQRkf9UhmTkMqho='
            );

        } else {
            console.log("GET : " + GLOBALS.API_URL + "PoliciaCuadrantes/usuarios/" + idUser);
            return Utils.httpGet(
                GLOBALS.API_URL + "PoliciaCuadrantes/usuario/" + idUser,
                'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOiIxNjIxNzYwODI5IiwiaWF0IjoiMTYyMTczMjAyOSIsImlkUHJvZmlsZSI6OCwianRpIjoiQjBCNkYwNjctQkZGNy00Qzc3LUJBNzUtQkMzQTdBRUJEREJDIiwic2VjcmV0IjoiWFRXTFhJTTRQNVFXVlZHSjNBU1lMWUNIQjc2QkdRS1RVQVRRVkxSVzM2SE1OQUREN0pRU0RCVzJVQVdTSUhKSUJJSVdWT0tUWlU3VVRMVjJBMjZKVUhYTjVENlk1NUZYVEpSS1cyUSIsInN1YiI6MjMsInZhbGlkaXR5IjoyODgwMH0=.rzmIzGd7Txm5qUAYumToeoiARzgWNQRkf9UhmTkMqho='
            );
        }
    },

    /* save: function(record) {
        if (typeof record === 'undefined') {
            return;
        }

        if (record.id_usuario == 0 || typeof(record.id_usuario) === 'undefined') {
            console.log("ADD : " + JSON.stringify(record));
            return Utils.httpPost(
                GLOBALS.API_URL + "PoliciaCuadrantes/personal/" + record.fk_idpersonal + "/usuario",
                record,
                'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOiIxNjIxNzYwODI5IiwiaWF0IjoiMTYyMTczMjAyOSIsImlkUHJvZmlsZSI6OCwianRpIjoiQjBCNkYwNjctQkZGNy00Qzc3LUJBNzUtQkMzQTdBRUJEREJDIiwic2VjcmV0IjoiWFRXTFhJTTRQNVFXVlZHSjNBU1lMWUNIQjc2QkdRS1RVQVRRVkxSVzM2SE1OQUREN0pRU0RCVzJVQVdTSUhKSUJJSVdWT0tUWlU3VVRMVjJBMjZKVUhYTjVENlk1NUZYVEpSS1cyUSIsInN1YiI6MjMsInZhbGlkaXR5IjoyODgwMH0=.rzmIzGd7Txm5qUAYumToeoiARzgWNQRkf9UhmTkMqho='
            );

        } else {
            console.log("EDIT : " + JSON.stringify(record));
            return Utils.httpUpdate(
                GLOBALS.API_URL + "PoliciaCuadrantes/personal/" + record.fk_idpersonal + "/usuario/" + record.id_usuario,
                record,
                'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOiIxNjIxNzYwODI5IiwiaWF0IjoiMTYyMTczMjAyOSIsImlkUHJvZmlsZSI6OCwianRpIjoiQjBCNkYwNjctQkZGNy00Qzc3LUJBNzUtQkMzQTdBRUJEREJDIiwic2VjcmV0IjoiWFRXTFhJTTRQNVFXVlZHSjNBU1lMWUNIQjc2QkdRS1RVQVRRVkxSVzM2SE1OQUREN0pRU0RCVzJVQVdTSUhKSUJJSVdWT0tUWlU3VVRMVjJBMjZKVUhYTjVENlk1NUZYVEpSS1cyUSIsInN1YiI6MjMsInZhbGlkaXR5IjoyODgwMH0=.rzmIzGd7Txm5qUAYumToeoiARzgWNQRkf9UhmTkMqho='
            );
        }
    }, */

    setPassword: function(record, idUser, Token) {

        if (typeof record === 'undefined') {
            return;
        }

        if (!(idUser == 0 || typeof(idUser) === 'undefined')) {

            return Utils.httpUpdate(
                GLOBALS.API_URL + "PoliciaCuadrantes/usuario/" + idUser + "/passwords",
                record,
                Token
            );
        }
    }

}